
import BaseCheckbox from "@/components/base/BaseCheckbox.vue";
import { InsuranceConfirmationEnum } from "@/models/enums";
import { Passenger } from "@/models/www/Booking";
import { InsuranceDocument } from "@/models/www/Insurance";
import { useInsuranceStore } from "@/store/insurance";
import useVuelidate from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
import { computed, defineComponent, PropType, reactive, ref } from "vue";
import InsurancePassenger from "./InsurancePassenger.vue";

export default defineComponent({
	components: {
		InsurancePassenger,
		BaseCheckbox,
	},
	props: {
		insuranceType: {
			type: String,
			required: true,
		},
		selected: {
			type: Boolean,
			default: false,
		},
		passengers: {
			type: Array as PropType<Passenger[]>,
			default: () => [],
		},
		documents: {
			type: Array as PropType<InsuranceDocument[]>,
			default: () => [],
			required: false,
		},
	},
	setup(props) {
		const insuranceStore = useInsuranceStore();

		const selectInsurance = () => {
			insuranceInput.value = props.insuranceType;
		};

		const active = computed(() => {
			return insuranceInput.value === props.insuranceType;
		});

		const hasAnyPassengerInsurance = computed(() => {
			return insuranceStore.getPassengers.length > 0;
		});

		const informationProvidedInput = computed({
			get(): boolean {
				return (
					(insuranceStore.getConfirmations.find(
						(c) =>
							c.type === InsuranceConfirmationEnum.InsuranceInformationProvided
					)?.value &&
						active.value) ??
					false
				);
			},
			set(value: boolean) {
				insuranceStore.setConfirmation({
					type: InsuranceConfirmationEnum.InsuranceInformationProvided,
					value: value,
				});
			},
		});

		const insuranceInput = computed({
			get(): string {
				return insuranceStore.getType;
			},
			set(value: string) {
				insuranceStore.setType(value);
			},
		});

		const state = reactive({
			passengerInsurance: hasAnyPassengerInsurance.value,
			informationProvided: informationProvidedInput.value,
		});

		const rules = {
			passengerInsurance: {
				v: helpers.withMessage(
					() => "Please select passengers(s)",
					() =>
						(insuranceStore.getType === props.insuranceType
							? hasAnyPassengerInsurance.value
							: true) as any
				),
			},
			informationProvided: {
				v: helpers.withMessage(
					() =>
						"Please confirm that you've been provided with and read the policy terms and conditions, significant exclusions and the status disclosure document.",
					() =>
						(insuranceStore.getType === props.insuranceType
							? informationProvidedInput.value
							: true) as any
				),
			},
		};

		const v$ = useVuelidate(rules, state);

		return {
			insuranceInput,
			selectInsurance,
			v$,
			informationProvidedInput,
			active,
		};
	},
});
